import messagesEn from './i18n/messages.en'

export const messages = {
  en: {
    ...messagesEn
  }
}



// WEBPACK FOOTER //
// ./src/locales/index.js